import { useCallback, useEffect, useState } from "react";

import { toError, type AsyncState } from "@/application/hooks/async-state";
import type { DashboardAnalytics } from "@/domain/models/analytics";
import { repositories } from "@/infrastructure/repositories";

export function useDashboardAnalytics() {
  const [state, setState] = useState<AsyncState<DashboardAnalytics>>({
    status: "loading",
    data: null,
    error: null,
  });

  const reload = useCallback(async () => {
    setState({ status: "loading", data: null, error: null });
    try {
      const data = await repositories.analytics.getDashboard();
      setState({ status: "success", data, error: null });
    } catch (error) {
      setState({ status: "error", data: null, error: toError(error) });
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { ...state, reload };
}
